import { Dispatch } from 'redux';

import backend from '../../../apis/backend';
import { ReduxState } from '../../state';
import { 
  setUserLocationInputs
} from '../actions';


// Initiator to lookup location address from latitude and longitude
export const getLocationAddress = (latitude: number, longitude: number) => {
  return async (dispatch: Dispatch, getState: () => ReduxState) => {
    try {
      const { locationFlow } = getState().location;
      const response = await backend.get(`/google/address-lookup`, {
        params: {
          latitude, longitude
        },
      }); 
      const results = response.data.results;
      let formattedAddress = '';

      if (results.length > 0) {
        formattedAddress = results[0].formatted_address;
      }
      dispatch(setUserLocationInputs({ ...locationFlow, address: formattedAddress }));

    } catch (error) {
      console.error("Error in looking up location address:", error);
    }
  }
}